import { type ValueType, type OptionType } from '@atlaskit/select';
import { TagColor } from '@atlaskit/tag';

import {
  TestTypeEnum,
  TestOutcomeEnum,
} from 'src/components/pipelines/components/test-management/types';

export const PAGE_LEN = 20;

export const encodeAutocompleteFilterValues = (
  values: ValueType<OptionType, true>
): string => {
  return values.map(v => v.value).toString();
};

export const decodeAutocompleteFilterValues = (
  queryParam?: string
): ValueType<OptionType, true> => {
  if (!queryParam) return [];

  return queryParam.split(',')?.map(param => ({ label: param, value: param }));
};

export const sortQueryParamIsAscending = (queryParam: string): boolean => {
  return queryParam.substring(0, 1) === '-';
};

export const addOrToggleSort = (key: string, queryParam?: string): string => {
  if (!queryParam?.includes(key)) return key;

  return sortQueryParamIsAscending(queryParam) ? key : `-${key}`;
};

const isInvalidInput = (seconds: number) => {
  return isNaN(seconds) || seconds === Infinity || seconds < 0;
};

export function formatTestDurations(seconds: number): string {
  if (isInvalidInput(seconds)) {
    return '--';
  }

  if (seconds < 0.1) {
    return 'less than 0.1s';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);

  if (hours > 0 || minutes > 0) {
    if (secs > 0) parts.push(`${Math.round(secs)}s`);
  } else {
    if (secs > 0) parts.push(`${secs.toFixed(1)}s`);
  }

  return parts.join(' ');
}

export function formatTestDurationsMs(milliseconds: number): string {
  if (isInvalidInput(milliseconds)) {
    return '--';
  }
  const seconds = milliseconds / 1000;
  return formatTestDurations(seconds);
}

export const getTagColor = (tag: string): TagColor => {
  if (tag === TestTypeEnum.Flaky) return 'yellow';

  if (tag === TestOutcomeEnum.Passed) return 'green';
  if (tag === TestOutcomeEnum.Error) return 'yellow';
  if (tag === TestOutcomeEnum.Failed) return 'red';

  return undefined;
};
